import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SubmissionForm from './SubmissionForm.jsx';
import { createSubmission } from 'Actions/submission';
import { pageTitleDecorator, authenticatedPageDecorator } from 'Decorators';
import IconCard from 'Common/Cards/IconCard.jsx';
import { loadUserData } from 'Actions/user';
import { FormattedMessage } from 'react-intl';
import { downloadFile } from 'Actions/submission';
import { COVER_LETTER_EXAMPLE_ID, ROLE_AUTHOR } from 'Constants';

@connect(store => ({
    loading: store.submissionData.loading,
    success: store.submissionData.success,
    error: store.submissionData.error,
    profileData: store.userData.user,
    userId: store.auth.user.id,
}), dispatch => ({
    createSubmission: (data, isAuthor) => dispatch(createSubmission(data, isAuthor)),
    loadUserData: id => dispatch(loadUserData(id)),
    downloadFile: (title) => dispatch(downloadFile(COVER_LETTER_EXAMPLE_ID, title)),
}))
@authenticatedPageDecorator()
@pageTitleDecorator('submissions')
export default class Submission extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        loading: PropTypes.bool,
        success: PropTypes.bool,
        error: PropTypes.bool,
        createSubmission: PropTypes.func.isRequired,
        profileData: PropTypes.object,
        userId: PropTypes.number,
        loadUserData: PropTypes.func,
        downloadFile: PropTypes.func,
        is: PropTypes.func,
    };

    state = {
        numChildren: 0,
        coauthorsList: [],
    };


    addCoauthor = () => {
        let coauthorsList = this.state.coauthorsList;
        coauthorsList.push(this.state.numChildren + 1);
        this.setState({
            coauthorsList: coauthorsList,
            numChildren: this.state.numChildren + 1,
        });
    };

    removeCoauthor = number => {
        let coauthorsList = this.state.coauthorsList;
        coauthorsList = coauthorsList.filter(item => item !== number);
        this.setState({
            coauthorsList: coauthorsList,
            numChildren: this.state.numChildren + 1,
        });
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    componentDidMount() {
        const { loadUserData, userId } = this.props;
        loadUserData(userId);
    }

    downloadFile = () => {
        const { downloadFile } = this.props;
        downloadFile(this.context.intl.formatMessage({ id: 'files.cover_letter_title' }));
    };

    handleCreate = (data) => {
        const { createSubmission, is } = this.props;
        const { coauthorsList } = this.state;
        const submissionData = Object.assign({}, data);
        if (submissionData.coauthors) {
            submissionData.coauthors = submissionData.coauthors.filter((coauthor, index) => {
                return coauthorsList.includes(index);
            });
        }
        createSubmission(submissionData, is(ROLE_AUTHOR) ? 1 : 0);
    };

    render() {
        const { profileData, loading } = this.props;
        const { coauthorsList, numChildren } = this.state;

        return (
            <div>
                <div className='data-table-filters-wrap-block' style={{paddingTop: '10px'}}>
                    <div className='data-table-title-block'>
                        <FormattedMessage id={'title.submission.create'} />
                    </div>
                </div>
                <IconCard
                    backButton={
                        {
                            to: '/',
                            title: 'button.to.submissions'
                        }
                    }
                    content={
                        <SubmissionForm
                            onSubmit={ this.handleCreate }
                            initialValues={ profileData }
                            className={'register'}
                            downloadFile={this.downloadFile}
                            loading={loading}
                            coauthorsList={coauthorsList}
                            numChildren={numChildren}
                            removeCoauthor={this.removeCoauthor}
                            addCoauthor={this.addCoauthor}
                        /> }
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Submission/Submission.jsx